<div class="flex flex-col">
  @if (isHidden) {
    <span class="text-base leading-[1] px-12">Breach history</span>
  }
  <div #chart class="w-full h-[73px]" [class.hidden]="isHidden"></div>
  @if (isLoading) {
    <div class="flex flex-col items-center justify-center h-[112px]">
      <nz-spin nzSimple nzSize="small" />
      <span class="text-sm mt-2">Loading breach history data ...</span>
    </div>
  }
  @if (isEmpty && !isLoading) {
    <nz-empty nzNotFoundImage="simple" nzNotFoundContent="No data was found for the selected time interval." />
  }
  @if (isError && !isLoading) {
    <twaice-fe-alert-panel
      class="py-24 flex flex-1 justify-self-center self-center"
      [type]="1"
      [title]="'Error'"
      [subTitle]="'Data could not be loaded'"
    />
  }
</div>
